import { render, staticRenderFns } from "./DeviceAssignmentList.vue?vue&type=template&id=1332ce8a&"
import script from "./DeviceAssignmentList.vue?vue&type=script&lang=js&"
export * from "./DeviceAssignmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports